import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '@/shared/api';
import type {
  CallWithDetails,
  CallsForLead,
  CallsForLeadQueryParams,
  CallsForHistory,
  CallsForHistoryQueryParams,
} from '@intone/shared';

import { convertParamsToString } from '@/shared/lib/queryParams';

/**
 * Hook to fetch a single call by ID
 */
export function useCall(callId: string | null) {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['call', callId],
    queryFn: async () => {
      return await apiClient<CallWithDetails>(`/calls/${callId}`);
    },
    enabled: !!callId,
    staleTime: 30 * 1000,
  })
}

/**
 * Hook to fetch calls for lead
 */
export function useCallsForLead(phone: string, params: CallsForLeadQueryParams) {
  const apiClient = useApiClient();
  const queryString = convertParamsToString<CallsForLeadQueryParams>(params);

  return useQuery({
    queryKey: ['calls-list-lead', phone, queryString],
    queryFn: async () => {
      return await apiClient<{ calls: CallsForLead[], totalCount: number, }>(`/calls/lead-calls/${phone}?${queryString}`);
    },
  })
}

/**
 * Hook to fetch calls for history page
 */
export function useCallsForHistory(campaignId: number | null, params: CallsForHistoryQueryParams ) {
  const apiClient = useApiClient();
  const queryString = convertParamsToString<CallsForHistoryQueryParams>(params);

  return useQuery({
    queryKey: ['calls-list-history', campaignId, params],
    queryFn: async () => {
      return await apiClient<{calls: CallsForHistory[], totalCount: number }>(`/calls/history-calls/${campaignId}?${queryString}`);
    },
    enabled: !!campaignId && !!params.pageSize,
  })
}